import { grpcClient } from 'api/grpc/client';
import { mapOr } from 'utils/fp';
import { head } from 'rambda';
import cogoToast from 'components/ToastMessage/ToastMessage';
import { VideoTrack } from '../models/VideoTrack';
import { Keyframe } from '../models/Keyframe';

class VideoTrackApi {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static async getVideoTracks(params: CF.API.PostAnnotationsSearchesCall) {
    try {
      const response = await grpcClient.postAnnotationsSearches(params);
      const hitList = mapOr(response, (r) => r.getHitsList(), []);
      const videoTrackList: VideoTrack[] = [];

      hitList.forEach((hit) => {
        const annotation = hit.getAnnotation();
        const frameList = annotation?.getData()?.getFramesList();

        frameList?.forEach((frame) => {
          frame
            .getData()
            ?.getRegionsList()
            .forEach((region) => {
              const trackId = region.getTrackId();
              const regionInfo = region.getRegionInfo()?.toObject() as CF.API.RegionInfo;
              const concept = head(region.getData()?.getConceptsList() || [])?.toObject() as CF.API.Concept;
              const time = frame.getFrameInfo()?.getTime();

              if (regionInfo && concept && time) {
                const keyframe = new Keyframe(trackId, regionInfo, concept, time);
                const videoTrack = new VideoTrack(trackId, [keyframe]);

                videoTrackList.push(videoTrack);
              }
            });
        });
      });

      return videoTrackList;
    } catch (error) {
      console.error(error);
      cogoToast.error('There was an unexpected error.');

      return [];
    }
  }
}

export { VideoTrackApi };
